module.exports = __webpack_public_path__ + "static/media/pdf-file.82b5cb0b.svg";